import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDemandTimePeriodList = createAsyncThunk("fetchDemandTimePeriodList", async () => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`/demand/list/timeperriod`, config);
	return response.data.data;
});

const DemandTimePeriodListSlice = createSlice({
	name: "DemandTimePeriodListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDemandTimePeriodList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchDemandTimePeriodList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchDemandTimePeriodList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default DemandTimePeriodListSlice.reducer;
